import { render, staticRenderFns } from "./learn-data-export.vue?vue&type=template&id=4430ddb5&scoped=true"
import script from "./learn-data-export.vue?vue&type=script&lang=js"
export * from "./learn-data-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430ddb5",
  null
  
)

export default component.exports